/**
 * Configurazione normative regionali: shell a tab sulle sezioni di
 * configurazione (RSA, regioni, profili, aree&mansioni, matrice requisiti,
 * standard aziendali, turni). Un solo punto d'ingresso in nav, ma ogni
 * sezione è un file separato (<500 righe) — a differenza della vecchia
 * pagina PHC_HR (un unico file da 5426 righe).
 */
import React, { useState } from "react";
import RsaConfigSection from "./RsaConfigSection";
import RegioniSection from "./RegioniSection";
import ProfiliSection from "./ProfiliSection";
import AreeMansioniSection from "./AreeMansioniSection";
import MatriceRequisitiSection from "./MatriceRequisitiSection";
import AziendaliSection from "./AziendaliSection";
import GruppiEquivalenzaSection from "./GruppiEquivalenzaSection";
import TurniSection from "./TurniSection";

const TABS = [
  { key: "rsa", label: "RSA", Component: RsaConfigSection },
  { key: "regioni", label: "Regioni", Component: RegioniSection },
  { key: "profili", label: "Profili ospiti", Component: ProfiliSection },
  { key: "aree", label: "Aree & Mansioni", Component: AreeMansioniSection },
  {
    key: "requisiti",
    label: "Matrice requisiti",
    Component: MatriceRequisitiSection,
  },
  {
    key: "aziendali",
    label: "Standard aziendali",
    Component: AziendaliSection,
  },
  {
    key: "sovrapponibilita",
    label: "Sovrapponibilità mansioni",
    Component: GruppiEquivalenzaSection,
  },
  { key: "turni", label: "Turni", Component: TurniSection },
];

export default function NormativePage() {
  const [active, setActive] = useState(TABS[0].key);
  const ActiveComponent = TABS.find((t) => t.key === active)?.Component;

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-bold text-gray-800">
          Normative regionali
        </h2>
        <p className="text-sm text-gray-500">
          Configurazione dei dati che guidano il calcolo del fabbisogno:
          regioni, profili ospiti, aree/mansioni, matrice requisiti, standard
          aziendali per-RSA, sovrapponibilità mansioni, turni.
        </p>
      </div>

      <div className="border-b border-gray-200 flex gap-1 overflow-x-auto">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setActive(t.key)}
            className={`px-3 py-2 text-sm whitespace-nowrap border-b-2 -mb-px ${
              active === t.key
                ? "border-primary-600 text-primary-700 font-medium"
                : "border-transparent text-gray-500 hover:text-gray-700"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {ActiveComponent && <ActiveComponent />}
    </div>
  );
}
